import Loader from 'react-loader-spinner';
import './preloader.css';

export const Preloader = (props) => (
  <div className='preloader_wrapper' {...props}>
    <Loader type='Watch' color='#F26939' height={60} width={60} />
  </div>
);
